document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const header = document.querySelector('#site-header');

  if (menuToggle && header) {
    menuToggle.addEventListener('click', function() {
      header.classList.toggle('menu-open');

      // Prevent body scroll when menu is open
      document.body.classList.toggle('menu-open');

      // Update aria-expanded for accessibility
      const isExpanded = header.classList.contains('menu-open');
      menuToggle.setAttribute('aria-expanded', isExpanded);
    });
  }
});
